import * as Yup from 'yup';

export const createProfileSchemaValidationSchema = Yup.object().shape({
  nickName: Yup.string()
    .required('Nickname is required field')
    .max(50, "Can't be more than 50 characters"),
  email: Yup.string().nullable().email('Email should be valid').required('Email is required field'),
});
